import ValidationType from '../ValidationType';
import { datesAreEqual } from "../../dateutil";
import moment from 'moment-timezone';

class EqualsDateTime extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      const current = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('YYYY-MM-DD h:mm a');
      const compare = moment(validation.value).utcOffset(moment(validation.value).utcOffset()).format('YYYY-MM-DD  h:mm a');
      if (!datesAreEqual(current, compare)) {
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_EQUAL_TO_SPECIFIED_VALUE',
          values: { value: validation.value },
          message: `Value should be equal to '${compare}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default EqualsDateTime;
